import { Pipe, PipeTransform } from '@angular/core';
import { differenceInCalendarDays } from 'date-fns';

@Pipe({
  standalone: true,
  name: 'numNights',
})
export class NumNightsPipe implements PipeTransform {
  transform(checkin: string | Date, checkout?: string | Date): number {
    if (!checkin || !checkout) {
      return 0;
    }
    return differenceInCalendarDays(new Date(checkout), new Date(checkin));
  }
}
